/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
    UpdateResponseFilling,
    UpdateResponseFillingFromJSON,
    UpdateResponseFillingFromJSONTyped,
    UpdateResponseFillingToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateResponseFillingResponse
 */
export interface UpdateResponseFillingResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof UpdateResponseFillingResponse
     */
    msg: string;
    /**
     * 
     * @type {UpdateResponseFilling}
     * @memberof UpdateResponseFillingResponse
     */
    entry: UpdateResponseFilling;
}

export function UpdateResponseFillingResponseFromJSON(json: any): UpdateResponseFillingResponse {
    return UpdateResponseFillingResponseFromJSONTyped(json, false);
}

export function UpdateResponseFillingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateResponseFillingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': UpdateResponseFillingFromJSON(json['entry']),
    };
}

export function UpdateResponseFillingResponseToJSON(value?: UpdateResponseFillingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': UpdateResponseFillingToJSON(value.entry),
    };
}


